import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'currency', data),
  get: (currencyId) => Ajax('get', `currency/${currencyId}`),
  add: (data) => Ajax('post', 'currency', data),
  edit: (currencyId, data) => Ajax('put', `currency/${currencyId}`, data),
  delete: (currencyId) => Ajax('delete', `currency/${currencyId}`),
  modifyStatus: (currencyId, isEnabled) => Ajax('put', `currency/${currencyId}/enable?enabled=${isEnabled}`),
};
